module.exports = __webpack_public_path__ + "static/media/skincare.b9ee6b42.svg";